import { FillRectOption } from '@tencent/alloy-editor';
import { ColorFill, SvgGraphics } from '@tencent/alloy-renderer';
import { convertColor } from '../utils/color';

function rectToPath(width: number, height: number) {
    return `M 0 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`;
}

export function createRectNode(rectOption: FillRectOption, id?: string): SvgGraphics | null {
    const { x, y, width, height, color } = rectOption;
    if (width === 0 || height === 0) {
        return null;
    }
    const path = rectToPath(width, height);
    const svgGraphics = new SvgGraphics(path);
    const finalColor = convertColor(color);
    const colorFill = new ColorFill(finalColor);
    svgGraphics.fill = colorFill;
    // 通过添加描边解决绘制背景之间有间隙的问题
    // 只有颜色不是半透明时才添加描边，因为半透明的颜色添加描边之后会导致形状一圈颜色变深，肉眼可以看出
    if (colorFill.color.alpha === 255) {
        svgGraphics.stroke = colorFill;
        svgGraphics.strokeWidth = 1;
    }
    svgGraphics.x = x;
    svgGraphics.y = y;
    if (id) {
        svgGraphics.id = id;
    }
    return svgGraphics;
}
